// Core imports
import React from 'react';

// Component imports
import SEO from '../components/SEO/SEO';

// Misc imports
import NdesTable from '../components/NDEs/NdesTable';

const NdesScreen = () => {
  return (
    <>
      <SEO
        title="Browse Near-Death Experiences \u2014 Searchable NDE Database"
        description="Search and browse thousands of verified near-death experiences (NDEs). Filter by type (peaceful, distressing, neutral, mixed), cause of death, Greyson scale score, out-of-body experiences, life reviews, and more."
        path="/ndes"
        jsonLd={[
          {
            '@context': 'https://schema.org',
            '@type': 'CollectionPage',
            name: 'Near-Death Experiences Database \u2014 NDE Archive',
            description: 'A searchable collection of thousands of verified near-death experiences (NDEs) with detailed categorization by type, Greyson scale score, cause of death, and NDE elements such as life reviews, out-of-body experiences, and entity encounters.',
            url: `${process.env.REACT_APP_SITE_URL || 'https://ndearchive.com'}/ndes`,
            about: [
              { '@type': 'Thing', name: 'Near-death experience' },
              { '@type': 'Thing', name: 'Greyson NDE Scale' },
              { '@type': 'Thing', name: 'Out-of-body experience' },
              { '@type': 'Thing', name: 'Life review' },
              { '@type': 'Thing', name: 'Distressing near-death experience' }
            ],
            keywords: 'near-death experience database, NDE search, NDE research, negative NDE, distressing NDE, negative near-death experience, Greyson scale, peaceful NDE, out-of-body experience, life review, NDE archive, NDE accounts, NDE reports, near death experience data'
          },
          {
            '@context': 'https://schema.org',
            '@type': 'BreadcrumbList',
            itemListElement: [
              { '@type': 'ListItem', position: 1, name: 'Home', item: process.env.REACT_APP_SITE_URL || 'https://ndearchive.com' },
              { '@type': 'ListItem', position: 2, name: 'Near-Death Experiences', item: `${process.env.REACT_APP_SITE_URL || 'https://ndearchive.com'}/ndes` }
            ]
          }
        ]}
      />
      <NdesTable />
    </>
  );
};

export default NdesScreen;
